module.exports = __webpack_public_path__ + "static/media/DSC09072_20180710_002-1.d5aff52b.jpg";